<span class="btn-line" [ngStyle]="{ 'border-style': tcLineStyle }"></span>

<span class="btn-icon before-icon {{ beforeIcon }}" *ngIf="beforeIcon"></span>

<span class="btn-text"><ng-content></ng-content></span>

<span class="btn-icon after-icon {{ afterIcon }}" *ngIf="afterIcon"></span>

<span class="btn-loader" *ngIf="load"><i class="icon icofont-spinner"></i></span>
